import React, { useEffect } from 'react';
import Header from './header';
import Sidebar from './sidebar';
import { Button, Form, Input, Select, message } from 'antd';
import axios from 'axios';
import { Navigate, useParams } from 'react-router-dom';

export const AddDeathForm = () => {
    const [form] = Form.useForm();
    const { id } = useParams();
    const [redirect, setRedirect] = React.useState(false);

    useEffect(() => {
        console.log('Family ID from URL:', id);
    }, [id]);

    const onFinish = async (values) => {
        try {
            const deathData = {
                name: values.name,
                genderType: values.gender,
                date: values.date,
                incidentType: values.incident,
                familyId: id,
            };

            const response = await axios.post(
                'https://ward3-chandrapur-api.palikaapp.com/api/family/family-death/save',
                deathData
            );

            if (response.status === 200) {
                message.success('मृत्यु संख्या सफलतापूर्वक सुरक्षित गरियो');
                form.resetFields();
                setRedirect(true);
            }
        } catch (error) {
            console.error(error);
            message.error('मृत्यु संख्या सुरक्षित गर्न असफल भयो');
        }
    };

    if (redirect) {
        return <Navigate to={`/family/${id}/details`} />;
    }

    return (
        <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
          <Header />
            {/* Sidebar */}
            <div className="lg:w-1/5 pt-20">
                
                <Sidebar />
            </div>

            {/* Form Section */}
            <div className="lg:w-4/5 p-6 pt-20 mt-5">
                <h1 className="text-xl lg:text-2xl font-bold mb-6 text-center lg:text-center">
                    मृत्यु संख्या थप फार्म
                </h1>
                <div className="flex justify-center">
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        className="w-full max-w-md bg-white p-6 shadow-lg rounded-md"
                    >
                        <Form.Item
                            label="नाम"
                            name="name"
                            rules={[{ required: true, message: 'कृपया नाम लेख्नुहोस्' }]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="लिङ्ग"
                            name="gender"
                            rules={[{ required: true, message: 'कृपया लिङ्ग चयन गर्नुहोस्' }]}
                        >
                            <Select className="border-gray-300 rounded-md">
                                <Select.Option value="MALE">पुरुष</Select.Option>
                                <Select.Option value="FEMALE">महिला</Select.Option>
                                <Select.Option value="OTHER">अरु</Select.Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="मिति"
                            name="date"
                            rules={[{ required: true, message: 'कृपया मिति चयन गर्नुहोस्' }]}
                        >
                            <Input type="date" className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="घटना प्रकार"
                            name="incident"
                            rules={[{ required: true, message: 'कृपया घटना चयन गर्नुहोस्' }]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-md"
                            >
                                सुरछित गर्नुहोस
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};
